<template>
  <div class="wrapper-setting">
    <div class="col">
      <el-row>
        <el-col :span="5">
          <div class="bg-white min-height">
            <home-sidebar active_item="charge"></home-sidebar>
          </div>
        </el-col>
        <el-col :span="19">
          <div class="bg-white ml-3 min-height">
            <div class="p-3">
              <div class="content-box pt-2 pb-2">
                <div class="title">账户充值
                </div>
              </div>
              <el-row>
                <el-col :span="12">
                  <el-card shadow="hover" style="background-color: #409EFF;">
                    <h3 style="color:white;margin-bottom: 0px;">当前账户余额：{{ balance.remain }} 个金币</h3>
                  </el-card>
                </el-col>
                <el-col :span="12"><el-link class="ml-3" style="padding-top: 50px;">给他人转账</el-link></el-col>
              </el-row>
              <div class="content-box pt-2 pb-2">
                <div class="title">充值金额
                </div>
              </div>
              <el-row :gutter="10">
                <el-col :span="6">
                  <el-card shadow="hover">
                    <h1 class="p-3" @click="form.totalAmount=100" style="margin-bottom: 0px;color:#666">100元</h1>
                  </el-card>
                </el-col>
                <el-col :span="6">
                  <el-card shadow="hover">
                    <h1 class="p-3" @click="form.totalAmount=200" style="margin-bottom: 0px;color:#666">200元</h1>
                  </el-card>
                </el-col>
                <el-col :span="6">
                  <el-card shadow="hover">
                    <h1 class="p-3" @click="form.totalAmount=500" style="margin-bottom: 0px;color:#666">500元</h1>
                  </el-card>
                </el-col>
                <el-col :span="6">
                  <el-card shadow="hover">
                    <h1 class="p-3" @click="form.totalAmount=1000" style="margin-bottom: 0px;color:#666">1000元</h1>
                  </el-card>
                </el-col>
              </el-row>

              <div class="content-box pt-2 pb-2">
                <div class="title">充值说明
                </div>
              </div>
              <div>
                <div>1. 充值后的金额可用于DATAWILL平台上的所有付费功能，方便您随时使用，无需每次都单独付费；</div>
                <div>2. 充值后系统将默认使用账户余额支付；</div>
                <div>3. 余额不足时，可选择组合付款，灵活应对各种需求；</div>
                <div>4. 充值后不支持退款，请您按需充值。</div>
                <div class="pt-2 pb-2">
                  <el-checkbox></el-checkbox>
                  我已阅读并同意《充值服务协议》
                </div>
              </div>
              <div class="pt-3">
                <el-button type="primary" @click="submitPayment">确定</el-button>
                <span class="pl-3">确认支付:{{ form.totalAmount }}</span>
              </div>
            </div>
          </div>
        </el-col>
      </el-row>
    </div>
  </div>
</template>
<script>
import api from "../../api/rest";
import util from "../../api/util";
import HomeSidebar from "../../components/HomeSidebar.vue";

export default {
  components: {HomeSidebar},
  data() {
    return {
      form: {
        alipayTraceNo: 'alipayTraceNo20241215ss1a1',
        subject: '用户充值',
        totalAmount: 0.1,
        traceNo: '',
      },
      listLoading: false,
      dataList: [],
      remain: 0,
      balance: {},
      msgTitle: ""
    }
  },
  methods: {
    handleOpen(key, keyPath) {
      console.log(key, keyPath);
    },
    handleClose(key, keyPath) {
      console.log(key, keyPath);
    },
    selsChange(val) {

    },
    handleCurrentChange(val) {

    },
    submitPayment() {
      const orderNumber = this.generateOrderNumber();
      this.form.traceNo = orderNumber
      const api_url = `/payment/alipay/create?alipayTraceNo=${this.form.alipayTraceNo}&subject=${encodeURIComponent(this.form.subject)}&totalAmount=${this.form.totalAmount}&traceNo=${this.form.traceNo}`;
      api.remote.doGet(api_url).then(function (response) {
        console.log(response)
        const tempDiv = document.createElement('div');
        tempDiv.innerHTML = response; // 插入返回的 HTML 表单
        document.body.appendChild(tempDiv);
        tempDiv.querySelector('form').submit(); // 自动提交表单
      })
    },
    generateOrderNumber() {
      const now = new Date();
      const year = now.getFullYear();
      const month = String(now.getMonth() + 1).padStart(2, '0');
      const day = String(now.getDate()).padStart(2, '0');
      const hours = String(now.getHours()).padStart(2, '0');
      const minutes = String(now.getMinutes()).padStart(2, '0');
      const seconds = String(now.getSeconds()).padStart(2, '0');
      const milliseconds = String(now.getMilliseconds()).padStart(3, '0');
      const randomDigits = String(Math.floor(Math.random() * 10000)).padStart(4, '0');
      return `${year}${month}${day}${hours}${minutes}${seconds}${milliseconds}${randomDigits}`;
    },
    init_page() {
      let api_url = '/balance/get'
      // 检查是否登录
      api.remote.doPost({}, api_url).then((res) => {
        // console.log(res.remain)
        this.balance = res
        console.log(this.balance)
      })
    }
  },
  filters: {
    formatMoney(num) {
      num = num / 10000
      return num.toString().replace(/\d+/, function (n) {
        return n.replace(/(\d)(?=(?:\d{3})+$)/g, '$1,');
      }) + "万";
    },
    formatDateTime(time) {
      var date = new Date(time)
      return date.format("yyyy-MM-dd")
    }
  },
  mounted() {
    this.init_page();
  }
}
</script>


// WEBPACK FOOTER //
// Charge.vue?b49c98f6